/**
 * Оркестратор рендеринга истории поиска.
 * Координирует отображение дерева, сворачивание веток и обработку кликов.
 *
 * Зависит от (загружаются до этого файла):
 *   render-helpers.js  — _buildHistoryTree, _computeActiveChain, _safeEscape, getDictNameFromResults
 *   render-item.js     — _renderHistoryItemRow
 *   render-branch.js   — _renderBranch
 *   render-filter.js   — filterHistoryItems
 *   render-save.js     — saveSearchToHistory
 *
 * # ⛓️ CURSOR_ANCHOR:search:history-render
 */

// Отобразить историю в выпадающем списке
function renderHistory(isSmart) {
  var historyList = document.getElementById('search-history-dropdown-list');
  if (!historyList) {
    return;
  }

  // Сброс фильтра — если остался от предыдущего сеанса, коннекторы будут скрыты CSS.
  historyList.classList.remove('is-filtered');

  var history = [];
  if (typeof getHistory === 'function') {
    history = getHistory();
  } else if (window.getHistory) {
    history = window.getHistory();
  }

  if (history.length === 0) {
    var emptyText = 'Search history is empty';
    if (typeof LANG_TEXTS !== 'undefined' && window.SEARCH_LANGUAGE) {
      var currentLang = window.SEARCH_LANGUAGE.getCurrentLang();
      if (LANG_TEXTS[currentLang] && LANG_TEXTS[currentLang].history_empty) {
        emptyText = LANG_TEXTS[currentLang].history_empty;
      }
    }
    var escapedText = _safeEscape(emptyText);
    historyList.innerHTML = '<div class="search-history-empty">' + escapedText + '</div>';

    var dropdownHeader = document.querySelector('.search-history-dropdown-header');
    if (dropdownHeader) dropdownHeader.style.display = 'none';
    return;
  }

  var dropdownHeader = document.querySelector('.search-history-dropdown-header');
  if (dropdownHeader) dropdownHeader.style.display = 'flex';

  var html = '';

  if (isSmart) {
    // Smart History: плоский список последних 5 записей (без дерева — быстрый доступ на фокусе).
    var sorted = history.slice().sort(function(a, b) {
      return (b.timestamp || 0) - (a.timestamp || 0);
    }).slice(0, 5);
    sorted.forEach(function(item) {
      html += _renderHistoryItemRow(item, {
        depth: 0,
        rootId: item.id,
        isRoot: true,
        hasChildren: false,
        activeChain: {}
      });
    });
  } else {
    // Полный режим: дерево.
    var tree = window._buildHistoryTree(history);
    var activeChain = window._computeActiveChain(window.CURRENT_HISTORY_ID, tree.nodes);

    tree.roots.forEach(function(root) {
      html += window._renderBranch(root, activeChain);
    });
  }

  historyList.innerHTML = html;

  // Сворачиваем все ветки кроме той, что содержит активный ID.
  // Если открыта панель цепочек — активная ветка не разворачивается,
  // т.к. цепочка уже видна в панели (избегаем дублирования контекста).
  if (!isSmart) {
    var chainPanelOpen = !!(window.CHAIN_PANEL && window.CHAIN_PANEL.isOpen && window.CHAIN_PANEL.isOpen());
    var activeRootId = null;
    if (!chainPanelOpen && window.CURRENT_HISTORY_ID) {
      var activeEl = historyList.querySelector('[data-id="' + window.CURRENT_HISTORY_ID + '"]');
      if (activeEl) activeRootId = activeEl.getAttribute('data-root-id');
    }
    var roots = historyList.querySelectorAll('.search-history-item.is-root.has-children');
    roots.forEach(function(rootEl) {
      var rid = rootEl.getAttribute('data-root-id');
      if (rid !== activeRootId) {
        _setBranchCollapsed(historyList, rid, true);
      } else {
        // Активная ветка: развёрнута только если панель цепочек закрыта.
        _setBranchCollapsed(historyList, rid, false);
      }
    });
  }

  // Пересчитываем высоту dropdown на мобильных устройствах после рендеринга
  if (window.innerWidth <= 768 && window.updateDropdownHeight) {
    setTimeout(function() {
      if (window.updateDropdownHeight) {
        window.updateDropdownHeight();
      }
    }, 0);
  }

  _applyZebra(historyList);
  _attachHistoryItemClickHandlers(historyList);
  _bindHoverPath(historyList);
}

/**
 * Сворачивает/разворачивает ветку. Скрывает/показывает все .search-history-item
 * с соответствующим data-root-id и глубиной > 0, обновляет класс на корне.
 */
function _setBranchCollapsed(historyList, rootId, collapsed) {
  if (!rootId) return;
  var rootEl = historyList.querySelector('.search-history-item.is-root[data-root-id="' + rootId + '"]');
  if (rootEl) {
    if (collapsed) rootEl.classList.add('branch-collapsed');
    else rootEl.classList.remove('branch-collapsed');
  }
  var children = historyList.querySelectorAll('.search-history-item[data-root-id="' + rootId + '"]:not(.is-root)');
  children.forEach(function(ch) {
    if (collapsed) ch.classList.add('branch-hidden');
    else ch.classList.remove('branch-hidden');
  });
  _applyZebra(historyList);
}

/**
 * Построчная зебра по ВИДИМЫМ рядам. CSS :nth-child считает все дети в DOM,
 * а свёрнутые ветки (.branch-hidden) и отфильтрованные (inline display:none)
 * остаются в DOM — из-за этого зебра «прыгает». Поэтому номеруем вручную.
 */
function _applyZebra(historyList) {
  if (!historyList) return;
  var items = historyList.querySelectorAll('.search-history-item');
  var visibleIdx = 0;
  items.forEach(function(el) {
    el.classList.remove('zebra-odd');
    if (el.classList.contains('branch-hidden')) return;
    if (el.style.display === 'none') return;
    if (visibleIdx % 2 === 0) el.classList.add('zebra-odd');
    visibleIdx++;
  });
}
window._applyZebra = _applyZebra;

/**
 * Единый хендлер клика по истории — делегированный, чтобы работал и после ререндеров.
 * Разделяет: клик по toggle → свернуть/развернуть ветку;
 *            клик по row → выполнить поиск этого термина.
 */
function _attachHistoryItemClickHandlers(historyList) {
  // Делегируем клик, чтобы один слушатель покрывал все ряды и toggle.
  if (historyList._historyClickBound) return;
  historyList._historyClickBound = true;

  historyList.addEventListener('click', function(e) {
    // Toggle ветки
    var toggleBtn = e.target.closest && e.target.closest('.search-history-toggle');
    if (toggleBtn) {
      e.stopPropagation();
      var rid = toggleBtn.getAttribute('data-toggle-root');
      var rootEl = historyList.querySelector('.search-history-item.is-root[data-root-id="' + rid + '"]');
      var collapsed = rootEl && rootEl.classList.contains('branch-collapsed');
      _setBranchCollapsed(historyList, rid, !collapsed);
      if (window.innerWidth <= 768 && window.updateDropdownHeight) {
        window.updateDropdownHeight();
      }
      return;
    }

    // Удаление записи: двойной клик для подтверждения.
    var deleteBtn = e.target.closest && e.target.closest('.search-history-delete');
    if (deleteBtn) {
      e.stopPropagation();
      if (deleteBtn.classList.contains('confirm')) {
        var delId = deleteBtn.getAttribute('data-delete-id');
        if (delId && window.deleteHistoryItem) {
          window.deleteHistoryItem(delId);
          renderHistory(false);
        }
      } else {
        historyList.querySelectorAll('.search-history-delete.confirm').forEach(function(btn) {
          btn.classList.remove('confirm');
        });
        deleteBtn.classList.add('confirm');
      }
      return;
    }

    // Клик по ряду → выполняем поиск.
    var row = e.target.closest && e.target.closest('.search-history-item');
    if (!row) return;
    e.stopPropagation();

    // Если кликнули на КОРНЕ цепочки (is-root + has-children) — редиректим на
    // последний активный термин этой цепочки: разворачиваем ветку и выполняем
    // поиск по запомненному термину, а не по корню. Это восстанавливает
    // контекст работы пользователя с цепочкой.
    var isChainRoot = row.classList.contains('is-root') && row.classList.contains('has-children');
    if (isChainRoot) {
      var rootId = row.getAttribute('data-id');
      var targetId = window.getChainLastActive ? window.getChainLastActive(rootId) : null;
      if (targetId && targetId !== rootId) {
        var targetRow = historyList.querySelector('[data-id="' + targetId + '"]');
        if (targetRow) {
          // Разворачиваем ветку, чтобы целевой ряд стал видимым в dropdown.
          _setBranchCollapsed(historyList, rootId, false);
          row = targetRow;
        }
      }
      // Панель цепочек откроется автоматически через CHAIN_PANEL.update() ниже,
      // если в поддереве выбранного элемента есть разветвление (_subtreeHasBranchingFrom).
      // Линейный хвост → только breadcrumb, панель не трогаем.
    }

    var term = row.getAttribute('data-term') || row.getAttribute('data-display-term') || '';
    var lang = row.getAttribute('data-lang');
    var searchType = row.getAttribute('data-search-type') || '';
    var termIndex = row.getAttribute('data-term-index');
    var clickedId = row.getAttribute('data-id') || null;
    var clickedParentId = row.getAttribute('data-parent-id') || null;

    // Сохраняем последний выбранный термин для восстановления фокуса.
    if (window.SEARCH_HISTORY && typeof window.SEARCH_HISTORY.setLastSelectedTerm === 'function') {
      var allVisible = Array.prototype.slice.call(historyList.querySelectorAll('.search-history-item:not(.branch-hidden)'));
      var idx = allVisible.indexOf(row);
      window.SEARCH_HISTORY.setLastSelectedTerm(term, idx >= 0 ? idx : 0, clickedId);
    }

    // Восстанавливаем контекст иерархии: активной становится кликнутая запись,
    // PENDING_PARENT_ID = её родитель (чтобы addToHistory дедупнулся на существующий id).
    // # ⛓️ CURSOR_ANCHOR:search:history-hierarchy
    if (clickedId) {
      window.CURRENT_HISTORY_ID = clickedId;
      if (window.setChainLastActive) window.setChainLastActive(clickedId);
      // Sync chain panel immediately (saveSearchToHistory may early-return on dedup)
      if (window.CHAIN_PANEL && window.CHAIN_PANEL.update) {
        window.CHAIN_PANEL.update(clickedId);
      }
    }
    window.PENDING_PARENT_ID = clickedParentId || null;
    window.PENDING_PARENT_TS = Date.now();

    // Stable GUID has priority over positional index for term navigation
    var termGuid = row.getAttribute('data-term-guid') || '';
    if (termGuid) {
      window.PENDING_TERM_GUID = termGuid;
      window.PENDING_TERM_INDEX = null;
    } else if (termIndex) {
      window.PENDING_TERM_GUID = null;
      window.PENDING_TERM_INDEX = termIndex;
    } else {
      window.PENDING_TERM_GUID = null;
      window.PENDING_TERM_INDEX = null;
    }

    var searchInput = document.getElementById('search');
    if (searchInput) searchInput.value = term;

    if (searchType) {
      var hiddenInput = document.getElementById('search-type-hidden');
      if (hiddenInput) {
        hiddenInput.value = searchType;
        var aiToggle = document.getElementById('search-mode-toggle');
        if (aiToggle) {
          if (searchType === 'smart') aiToggle.classList.add('active');
          else aiToggle.classList.remove('active');
        }
      }
    }

    if (typeof window.closeHistoryDropdown === 'function') {
      window.closeHistoryDropdown();
    }

    var currentLang = window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
    if (currentLang !== lang) {
      if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.switchLanguage) {
        window.SEARCH_LANGUAGE.switchLanguage(lang, term, searchType);
      } else if (window.SEARCH && window.SEARCH.performSearch) {
        window.SEARCH.performSearch(null);
      }
    } else if (window.SEARCH && window.SEARCH.performSearch) {
      window.SEARCH.performSearch(null);
    }
  });
}

/**
 * Binds hover-path highlighting on a container with history items.
 * On mouseenter: highlights the path from root to hovered item (.hover-chain class).
 * On mouseleave: removes all highlights.
 * Works on both dropdown and chain panel.
 */
function _bindHoverPath(container) {
  if (!container || container._hoverPathBound) return;
  container._hoverPathBound = true;

  var _lastHoveredId = null;

  // mouseover bubbles from any descendant — find the closest item
  container.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('.search-history-item');
    if (!item) {
      if (_lastHoveredId) { _clearHoverChain(container); _lastHoveredId = null; }
      return;
    }
    var id = item.getAttribute('data-id');
    if (id === _lastHoveredId) return; // same item, no work
    _lastHoveredId = id;
    _applyHoverChain(container, item);
  });

  // mouseout — only clear when leaving the container entirely
  container.addEventListener('mouseleave', function () {
    _lastHoveredId = null;
    _clearHoverChain(container);
  });
}

/**
 * Hover path highlighting — replicates the EXACT .ap logic from render-branch.js.
 *
 * Walks the history tree computing the same flags (laterSiblingInChain,
 * hasChildInChain, selfEndpoint, activeContinuations) but for the HOVER chain.
 * Then applies .hover-ap to the same connectors that would get .ap.
 */
function _applyHoverChain(container, itemEl) {
  _clearHoverChain(container);

  var id = itemEl.getAttribute('data-id');
  if (!id) return;

  var history = (typeof getHistory === 'function') ? getHistory() : (window.getHistory ? window.getHistory() : []);
  if (!history.length) return;

  var tree = window._buildHistoryTree(history);
  var hoverChain = window._computeActiveChain(id, tree.nodes);
  if (!hoverChain || Object.keys(hoverChain).length === 0) return;

  // Walk the tree and compute flags for each item — same logic as render-branch.js
  var flags = {}; // itemId → { v, h, cc, vlines:{depth:true}, split }

  function walkChildren(children, depth, parentActiveCont, parentInChain) {
    var chainAfter = new Array(children.length);
    var found = false;
    for (var j = children.length - 1; j >= 0; j--) {
      if (hoverChain[children[j].item.id]) found = true;
      chainAfter[j] = found;
    }

    for (var i = 0; i < children.length; i++) {
      var ch = children[i];
      var isLast = (i === children.length - 1);
      var inChain = !!hoverChain[ch.item.id];
      var laterSib = parentInChain && (i + 1 < children.length) && chainAfter[i + 1];
      var endpoint = inChain && parentInChain && !laterSib;
      var childInChain = false;
      for (var ci = 0; ci < ch.children.length; ci++) {
        if (hoverChain[ch.children[ci].item.id]) { childInChain = true; break; }
      }

      // vline flags: inherit parent's active continuations
      var vlFlags = {};
      for (var d in parentActiveCont) vlFlags[d] = true;

      flags[ch.item.id] = {
        v: laterSib || endpoint,
        h: inChain,
        cc: childInChain,
        vlines: vlFlags,
        split: endpoint && !isLast
      };

      if (ch.children.length > 0) {
        var childACont = {};
        for (var dk in parentActiveCont) childACont[dk] = true;
        if (!isLast && parentInChain && chainAfter[i + 1]) {
          childACont[depth - 1] = true;
        }
        walkChildren(ch.children, depth + 1, childACont, inChain);
      }
    }
  }

  tree.roots.forEach(function (root) {
    var inChain = !!hoverChain[root.item.id];
    var childInChain = false;
    for (var i = 0; i < root.children.length; i++) {
      if (hoverChain[root.children[i].item.id]) { childInChain = true; break; }
    }
    flags[root.item.id] = { v: false, h: false, cc: childInChain, vlines: {}, split: false };
    if (root.children.length > 0) {
      walkChildren(root.children, 1, {}, inChain);
    }
  });

  // Apply flags to DOM — same connectors that would get .ap now get .hover-ap
  container.querySelectorAll('.search-history-item').forEach(function (el) {
    var elId = el.getAttribute('data-id');
    var f = flags[elId];
    if (!f) return;

    if (hoverChain[elId]) el.classList.add('hover-chain');

    if (f.h) {
      var ch = el.querySelector('.hi-conn-h');
      if (ch) ch.classList.add('hover-ap');
    }

    if (f.v) {
      // f.split = endpoint item NOT last-in-branch: only top half should be orange.
      var hasDomSplit = f.split && el.querySelector('.hi-conn-v-top');
      el.querySelectorAll('.hi-conn-v').forEach(function (cv) {
        if (f.split) {
          if (cv.classList.contains('hi-conn-v-bottom')) return;
          if (!hasDomSplit) {
            // DOM has single full-height hi-conn-v. Can't clip without destroying
            // structural line. Create overlay span on top instead.
            var ov = document.createElement('span');
            ov.className = 'hover-ap-overlay';
            ov.style.setProperty('--c-depth', cv.style.getPropertyValue('--c-depth'));
            el.appendChild(ov);
            return;
          }
        }
        cv.classList.add('hover-ap');
      });
    }

    if (f.cc) {
      var cc = el.querySelector('.hi-child-conn');
      if (cc) cc.classList.add('hover-ap');
    }

    el.querySelectorAll('.hi-vline').forEach(function (vl) {
      var vd = parseInt(vl.style.getPropertyValue('--vl-depth') || '0', 10);
      if (f.vlines[vd]) vl.classList.add('hover-ap');
    });
  });
}

function _clearHoverChain(container) {
  container.querySelectorAll('.search-history-item.hover-chain').forEach(function (el) {
    el.classList.remove('hover-chain');
  });
  container.querySelectorAll('.hover-ap').forEach(function (el) {
    el.classList.remove('hover-ap');
  });
  container.querySelectorAll('.hover-ap-overlay').forEach(function (el) {
    el.remove();
  });
}

// Экспортируем функции в глобальную область видимости
// (прочие функции экспортируются из своих исходных файлов —
//  filterHistoryItems в render-filter.js, saveSearchToHistory в render-save.js,
//  getDictNameFromResults в render-helpers.js).
window.renderHistory = renderHistory;
window._bindHoverPath = _bindHoverPath;
